// extracted by mini-css-extract-plugin
module.exports = {"mainPageContentCont":"styles_mainPageContentCont__36IpN","contHidden":"styles_contHidden__2rmxX"};